/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendActualProductDto } from '../../models/backend-actual-product-dto';
import { BackendActualProductRequestDto } from '../../models/backend-actual-product-request-dto';

export interface MonitoringActualsProductsCreate$XWwwFormUrlencoded$Params {
  /**
   * ID сценария для фильтрации списка
   */
  scenario_id?: number;

  /**
   * Поиск по текстовым полям сущности
   */
  search?: string;
  body: BackendActualProductRequestDto;
}

export function monitoringActualsProductsCreate$XWwwFormUrlencoded(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringActualsProductsCreate$XWwwFormUrlencoded$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendActualProductDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringActualsProductsCreate$XWwwFormUrlencoded.PATH, 'post');
  if (params) {
    rb.query('scenario_id', params.scenario_id, {});
    rb.query('search', params.search, {});
    rb.body(params.body, 'application/x-www-form-urlencoded');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendActualProductDto>;
    }),
  );
}

monitoringActualsProductsCreate$XWwwFormUrlencoded.PATH = '/api/monitoring/actuals/products/';
